import { CoverageDebrisRemovalValue, CoverageEarthquakeValue, CoverageEquipmentBreakdownValue, CoverageGolfCartValue, CoverageIdentityFraudExpenseValue, CoverageInflationGuardValue, CoverageLossAssessmentValue, CoverageWaterBackupAndSumpOverflowValue, PersonalPropertyType, ResidenceBurglaryValue, } from "./operations.generated";
export const earthquakeGraphQLToViewMap = {
    [CoverageEarthquakeValue.Percent10]: "10%",
    [CoverageEarthquakeValue.Percent15]: "15%",
    [CoverageEarthquakeValue.Percent20]: "20%",
};
export const equipmentBreakdownGraphQLToViewMap = {
    [CoverageEquipmentBreakdownValue.Dollars100K]: "$100,000",
};
export const identityFraudExpenseGraphQLToViewMap = {
    [CoverageIdentityFraudExpenseValue.Dollars15K]: "$15,000",
};
export const golfCartGraphQLToViewMap = {
    [CoverageGolfCartValue.One]: "1",
    [CoverageGolfCartValue.Two]: "2",
    [CoverageGolfCartValue.Three]: "3",
    [CoverageGolfCartValue.Four]: "4",
    [CoverageGolfCartValue.Five]: "5",
};
export const personalPropertyTypeGraphQLToViewMap = {
    [PersonalPropertyType.Jewelry]: "Jewelry",
    [PersonalPropertyType.GunsAndAmmunition]: "Guns and Ammunition",
    [PersonalPropertyType.FineArts]: "Fine Arts",
    [PersonalPropertyType.StampsBooks]: "Stamps/Books",
    [PersonalPropertyType.CameraRecorderMedia]: "Camera/Recorder/Media",
    [PersonalPropertyType.RareAndCurrentCoins]: "Rare and Current Coins",
    [PersonalPropertyType.ComputerEquipment]: "Computer Equipment",
    [PersonalPropertyType.Furs]: "Furs",
    [PersonalPropertyType.GolfersEquipment]: "Golfer's Equipment",
    [PersonalPropertyType.MusicalInstruments]: "Musical Instruments",
    [PersonalPropertyType.Silverware]: "Silverware",
    [PersonalPropertyType.Tools]: "Tools",
    [PersonalPropertyType.Bikes]: "Bikes",
    [PersonalPropertyType.AllOther]: "All Other",
};
export const residenceBurglaryLimitGraphQLToViewMap = {
    [ResidenceBurglaryValue.Dollars5K]: "$5,000",
    [ResidenceBurglaryValue.Dollars10K]: "$10,000",
    [ResidenceBurglaryValue.Dollars15K]: "$15,000",
    [ResidenceBurglaryValue.Dollars20K]: "$20,000",
    [ResidenceBurglaryValue.Dollars30K]: "$30,000",
    [ResidenceBurglaryValue.Dollars40K]: "$40,000",
    [ResidenceBurglaryValue.Dollars50K]: "$50,000",
};
export const waterBackupAndSumpOverflowGraphQLToViewMap = {
    [CoverageWaterBackupAndSumpOverflowValue.Dollars5K]: "$5,000",
    [CoverageWaterBackupAndSumpOverflowValue.Dollars10K]: "$10,000",
    [CoverageWaterBackupAndSumpOverflowValue.Dollars25K]: "$25,000",
};
export const lossAssessmentGraphQLToViewMap = {
    [CoverageLossAssessmentValue.Dollars1K]: "$1,000",
    [CoverageLossAssessmentValue.Dollars5K]: "$5,000",
};
export const debrisRemovalGraphQLToViewMap = {
    [CoverageDebrisRemovalValue.Dollars5K]: "$5,000",
    [CoverageDebrisRemovalValue.Dollars10K]: "$10,000",
};
export const inflationGuardGraphQLToViewMap = {
    [CoverageInflationGuardValue.Percent3]: "3%",
};
